import { useNavigate } from "react-router-dom";
import BlueTableHeading from "../../../../components/common/AdminCommonComponents/BlueTableHeading/BlueTableHeading"
import ActionButton from "../../../../components/common/AdminCommonComponents/Buttons/ActionButton/ActionButton";
import DynamicDatatable from "../../../../components/common/AdminCommonComponents/DynamicDatatable/DynamicDatatable";

const ActiveCampaigns = () => {

  const navigate = useNavigate()

  const actions = [
    { label: 'View Details', action: () => navigate('/advertisement/active-campaign-detail') },
    { label: 'Edit', action: () => {} },
    { label: 'Delete', action: () => {} },
    { label: 'Change status ', action: () => {} },
  ]

  const tableData = [
    { sr: '1', campaignId: 'AC001', sellerName: 'Techmart', adType: 'Sponsoredvideoload', startDate: '01-dec-2024', endDate: '01-dec-2024', dailyBudged: '$50/day', clicks: '1200', impressions: '500000', totalSpend: '$350', },
    { sr: '1', campaignId: 'AC001', sellerName: 'Techmart', adType: 'Sponsoredvideoload', startDate: '01-dec-2024', endDate: '01-dec-2024', dailyBudged: '$50/day', clicks: '1200', impressions: '500000', totalSpend: '$350', },
    { sr: '1', campaignId: 'AC001', sellerName: 'Techmart', adType: 'Sponsoredvideoload', startDate: '01-dec-2024', endDate: '01-dec-2024', dailyBudged: '$50/day', clicks: '1200', impressions: '500000', totalSpend: '$350', },
    { sr: '1', campaignId: 'AC001', sellerName: 'Techmart', adType: 'Sponsoredvideoload', startDate: '01-dec-2024', endDate: '01-dec-2024', dailyBudged: '$50/day', clicks: '1200', impressions: '500000', totalSpend: '$350', },
    { sr: '1', campaignId: 'AC001', sellerName: 'Techmart', adType: 'Sponsoredvideoload', startDate: '01-dec-2024', endDate: '01-dec-2024', dailyBudged: '$50/day', clicks: '1200', impressions: '500000', totalSpend: '$350', },
  ]

  const columns = [
    { name: 'Sr. No.', selector: (row) => row.sr, sortable: true, grow: 0.5 },
    { name: 'Campaign ID', selector: (row) => row.campaignId, sortable: true },
    { name: 'Seller Name', selector: (row) => row.sellerName, sortable: true },
    { name: 'Ad Type', selector: (row) => row.adType, sortable: true },
    { name: 'Start Date', selector: (row) => row.startDate, sortable: true },
    { name: 'End Date', selector: (row) => row.endDate, sortable: true },
    { name: 'Daily Budget', selector: (row) => row.dailyBudged, sortable: true },
    { name: 'Clicks', selector: (row) => row.clicks, sortable: true },
    { name: 'Impressions', selector: (row) => row.impressions, sortable: true },
    { name: 'Total Spend', selector: (row) => row.totalSpend, sortable: true },
    { name: 'Action', cell: () => <ActionButton options={actions} />, center: 'true' },
  ];
  

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f2f2f2", padding: "1rem" }}>
      <div className="bg-white shadow">
        <BlueTableHeading className="px-4 py-3 fw-semibold fs-5">Active Campaigns</BlueTableHeading>

        <div className="p-3">
          <DynamicDatatable columns={columns} data={tableData} type='gray' />
        </div>
      </div>
    </div>
  )
}

export default ActiveCampaigns
